/**
 * Converts all non-string values in an object to JSON strings, but only for 1 level deep.
 * Only the first depth to avoid complex objects inside heap events.
 *
 * This is motivated by https://developers.heap.io/reference/track requiring the event properties
 * to have values of only string or number.
 *
 * @param {Object} obj - the object to convert
 * @returns {Object} - a new object with all non-string values converted to strings
 * @example
 *  stringifyObjectValuesShallow({ a: 1234, b: '2', c: { d: 3 }, e: false })
 *                          --> { a: '1234', b: '2', c: '{ "d": 3 }', e: 'false' }
 */
function stringifyObjectValuesShallow(obj) {
    if (!obj) {
        return {};
    }

    return Object.keys(obj).reduce((newObj, key) => {
        const objValue = obj[key];
        newObj[key] = typeof objValue === 'string'
            ? objValue
            : JSON.stringify(objValue);

        return newObj;
    }, {});
}

export default stringifyObjectValuesShallow;
